import React from 'react'
import { Offcanvas } from 'react-bootstrap'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpRightFromSquare} from '@fortawesome/free-solid-svg-icons'

const CustomOffcanvas = ({show, onModalClose, width, children, headline, onClickExpand}) => {

  const style = {
    offcanvas: {
      width: width,
      top: 60
    }
  }

  return(
    <Offcanvas style={{...style.offcanvas}} placement={'end'} show={show} onHide={onModalClose} backdrop={true} scroll={false} >
      <Offcanvas.Header closeButton>
        {onClickExpand && <Offcanvas.Title style={{marginRight: 15, cursor: 'pointer'}}><FontAwesomeIcon onClick={onClickExpand} style={{color: "#6c757d", margin: "auto"}} icon={faUpRightFromSquare} /></Offcanvas.Title>}
        <Offcanvas.Title className={'display-6 fw-bold'}>{headline}</Offcanvas.Title>
      </Offcanvas.Header>
      {children}
    </Offcanvas>
  )
}

export default CustomOffcanvas